import type { User } from '@repo/common/types';
import { apiClient } from './api-client';
import type { ResultOk } from '@repo/common/types/result';

const basePath = 'v1/users';
const endpoints = { root: basePath };

async function currentUser() {
  try {
    const data = await apiClient
      .get<ResultOk<User>>(`${endpoints.root}/me`)
      .json();

    return data.data;
  } catch (_err) {
    return null;
  }
}

export const userClient = {
  currentUser,
};
